/* eslint-disable */
import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { logOutUser, generateToastError } from '../../../utils';
import { queryKeys } from '../queryKeys';

// Checkin and Checkout Logic stars from here

const httpStatuses = { unauthorized: 401, error: 500 };

export const useMutationPairWithEdifier = (
  toast,
  userToken,
  navigate,
  queryClient,
  rankedEdifierPayload,
  setRankedEdifierPayload
) => {
  const queryKey = [queryKeys.pairWithEdifier];

  const queryFn = () => {
    const payload = {
      ...rankedEdifierPayload,
    };

    const edifierId = payload?.id;

    delete payload['id'];
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/teacher/pair/${edifierId}`, payload, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
  };

  return useMutation(queryKey, queryFn, {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success(`${success?.data?.message}`, {
        duration: 3000,
      });

      setRankedEdifierPayload({});

      // navigate('/dashboard/paired');

      // queryClient.invalidateQueries({ queryKey: [queryKeys.userCheckInStatus] });

      // queryClient.invalidateQueries({ queryKey: [queryKeys.getPairedEdifiers] });
    },
    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }

      generateToastError(toast, e);
    },
  });
};

const ROLES_NEEDING_PAIRED_EDIFIERS = ['TEACHER', 'COACH'];

export const useQueryGetPairedEdifiers = (
  userToken,
  navigate,
  toast,
  userRoleOrTotalRoles,
  shouldFetchOnCurrentPage = true
) => {
  const queryKey = [queryKeys.getPairedEdifiers];

  const roles = Array.isArray(userRoleOrTotalRoles)
    ? userRoleOrTotalRoles
    : userRoleOrTotalRoles ? [userRoleOrTotalRoles] : [];
  const shouldFetch = roles.some((r) => ROLES_NEEDING_PAIRED_EDIFIERS.includes(String(r || '').toUpperCase()));

  const queryFn = ({ queryKey }) =>
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/teacher/get-pairs`, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
  return useQuery(queryKey, queryFn, {
    enabled: !!userToken && shouldFetch && shouldFetchOnCurrentPage,
    retry: 0,
    refetchOnWindowFocus: false,
    cacheTime: 72000,

    staleTime: Infinity,

    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }
      generateToastError(toast, e);
    },
  });
};

export const useQueryGetPairedUsersAdmin = (userToken, navigate, toast, page = 1, limit = 10, search = '') => {
  const queryKey = [queryKeys.getPairedUsersAdmin, { page, limit, search }];

  const queryFn = ({ queryKey }) => {
    const params = {
      page: queryKey[1].page,
      limit: queryKey[1].limit,
      ...(queryKey[1].search && { search: queryKey[1].search })
    };

    return axios.get(`${process.env.REACT_APP_SERVER_URL}/api/admin/pairs`, {
      headers: { Authorization: `Bearer ${userToken}` },
      params
    });
  };
  return useQuery(queryKey, queryFn, {
    enabled: true,
    retry: 0,
    refetchOnWindowFocus: false,
    cacheTime: 72000,

    staleTime: Infinity,
    select: (data) => {
      const refactoredData = [];

      // Handle both old and new API response structures
      const pairs = data?.data?.data?.pairs || data?.data?.data || [];
      const pagination = data?.data?.data?.pagination;

      pairs.forEach((item) => {
        // Get all users in the pair
        const users = item.users || [];
        if (users.length >= 2) {
          // Find different role combinations
          const teacher = users.find((user) => user.role === 'TEACHER');
          const coach = users.find((user) => user.role === 'COACH' || user.role === 'SITE-LEADER');


          // Handle TEACHER + COACH pairs
          if (teacher && coach) {
            refactoredData.push({
              _id: item._id,
              'Teacher Name': `${teacher.fname} ${teacher.lname}`,
              'Teacher Email': teacher.email,
              'Teacher Image': teacher.image || null,
              'Edifier Name': `${coach.fname} ${coach.lname}`,
              usersInPair: { user1: coach?._id, user2: teacher?._id },
              'Edifier Email': coach.email,
              'Edifier Image': coach.image || null,
              'Paired Since': new Date(item?.timestamp).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              }),
              lastSession: item?.lastSession,
            });
          }
        }
      });

      // Return data with pagination info
      // If server provides pagination info, use it; otherwise use client-side count
      return {
        data: refactoredData,
        pagination: pagination ? {
          totalCount: pagination.totalPairs, // Map totalPairs to totalCount for consistency
          currentPage: pagination.currentPage,
          totalPages: pagination.totalPages,
          hasNextPage: pagination.hasNextPage,
          hasPrevPage: pagination.hasPrevPage,
          limit: pagination.limit
        } : {
          totalCount: refactoredData.length,
          currentPage: 1,
          totalPages: 1,
          hasNextPage: false,
          hasPrevPage: false,
          limit: 10
        }
      };
    },
    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }
      generateToastError(toast, e);
    },
  });
};

export const useMutationEndTraining = (userToken, navigate, toast, payload, setTrainingEndingPayload, queryClient) => {
  const queryKey = [queryKeys.endUsersTraining, payload];

  const queryFn = () =>
    axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/admin/pair/${payload?.id}`,
      {},
      {
        headers: { Authorization: `Bearer ${userToken}` },
      }
    );
  return useMutation(queryKey, queryFn, {
    retry: 0,
    refetchOnWindowFocus: false,
    cacheTime: 72000,

    staleTime: Infinity,
    onSuccess: (success) => {
      toast.success(`${success?.data?.message}`, {
        duration: 3000,
      });

      setTrainingEndingPayload({});

      // navigate('/dashboard/paired');

      // queryClient.invalidateQueries({ queryKey: [queryKeys.userCheckInStatus] });

      // queryClient.invalidateQueries({ queryKey: [queryKeys.getPairedEdifiers] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.getPairedUsersAdmin] });
    },

    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }
      generateToastError(toast, e);
    },
  });
};

export const useMutationEndPairing = (userToken, navigate, toast, payload, setPairingEndingPayload, queryClient) => {
  const queryKey = [queryKeys.endUsersPairing, payload];

  const queryFn = () =>
    axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/admin/unpair`,
      { ...payload },
      {
        headers: { Authorization: `Bearer ${userToken}` },
      }
    );
  return useMutation(queryKey, queryFn, {
    retry: 0,
    refetchOnWindowFocus: false,
    cacheTime: 72000,

    staleTime: Infinity,
    onSuccess: (success) => {
      toast.success(`${success?.data?.message}`, {
        duration: 3000,
      });
      window.location.reload();

      setPairingEndingPayload({});

      // navigate('/dashboard/paired');

      // queryClient.invalidateQueries({ queryKey: [queryKeys.userCheckInStatus] });

      queryClient.invalidateQueries({ queryKey: [queryKeys.getPairedUsersAdmin] });
    },

    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }
      generateToastError(toast, e);
    },
  });
};

export const useMutationCreatePair = (userToken, navigate, toast, payload, setCreatePairPayload, queryClient) => {
  const queryKey = [queryKeys.createPair];

  const queryFn = () => {
    return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/admin/pair/create-pair`, payload, {
      headers: { Authorization: `Bearer ${userToken}` },
    });
  };

  return useMutation(queryKey, queryFn, {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success(`${success?.data?.message}`, {
        duration: 3000,
      });

      setCreatePairPayload({});

      queryClient.invalidateQueries({ queryKey: [queryKeys.getPairedUsersAdmin] });
    },
    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }

      generateToastError(toast, e);
    },
  });
};